import { render, staticRenderFns } from "./LibraryReadingHistoryManager.vue?vue&type=template&id=288e7cd3&"
import script from "./LibraryReadingHistoryManager.vue?vue&type=script&lang=ts&"
export * from "./LibraryReadingHistoryManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports